module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [(_vm.showInputName) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.name),
      expression: "value.name"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "placeholder": "Widget Name"
    },
    domProps: {
      "value": (_vm.value.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "name", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-2 bg-lightest radius-normal border-light p-3 col-sm-12"
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex mb-1"
  }, [_c('span', {
    staticClass: "bold pointer underlined mr-2",
    on: {
      "click": function($event) {
        return _vm.allProductsInput(true)
      }
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('span', {
    staticClass: "bold pointer underlined",
    on: {
      "click": function($event) {
        return _vm.allProductsInput(false)
      }
    }
  }, [_vm._v("Clear All")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 px-3 pb-3 categoriesArea"
  }, _vm._l((_vm.value.categoryProductList), function(category) {
    return _c('div', {
      staticClass: "categoriesHolder p-2 bg-lighter radius-normal"
    }, [_c('div', {
      staticClass: "d-flex flex-row bold"
    }, [_c('checkbox', {
      on: {
        "input": function($event) {
          return _vm.categoryInput($event, category)
        }
      },
      model: {
        value: (category.widgetCategory.isActive),
        callback: function($$v) {
          _vm.$set(category.widgetCategory, "isActive", $$v)
        },
        expression: "category.widgetCategory.isActive"
      }
    }), _vm._v("\n                        " + _vm._s(category.widgetCategory.category.name) + "\n                        "), _c('i', {
      staticClass: "fas fa-cog ml-2 pointer dark fs-large",
      on: {
        "click": function($event) {
          return _vm.openSettings(category)
        }
      }
    })], 1), _vm._v(" "), _vm._l((category.widgetProducts), function(widgetProduct) {
      return _c('div', {
        staticClass: "d-flex flex-row ml-2 mt-2"
      }, [_c('checkbox', {
        model: {
          value: (widgetProduct.isActive),
          callback: function($$v) {
            _vm.$set(widgetProduct, "isActive", $$v)
          },
          expression: "widgetProduct.isActive"
        }
      }), _vm._v("\n                        " + _vm._s(widgetProduct.product.name) + "\n                    ")], 1)
    })], 2)
  }), 0)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6af92c90", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af92c90"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/widget/widgetComposer.vue
// module id = 2578
// module chunks = 0